module.exports = __webpack_public_path__ + "static/media/logo.94ee59d0.png";